﻿import { Component, EventEmitter, OnInit, ViewChild } from "@angular/core";
import { Params, Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";

// Import Model
import { UserModel, UserRoleListModel } from "../../../../model/jubili/setting-user/user-data";
import { EditRoleModel } from "../../../../model/jubili/setting-user/edit-user";
import { EditRoleService } from "../../../../service/api/jubili/edit-role.service";
import { AuthenticationService } from "../../../../service/api/auth/auth.service";
import { NgbModal, NgbModalRef } from "../../../../../../node_modules/@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "bo-jub-edit-role",
    styleUrls: ["./edit-role.component.scss"],
    templateUrl: "./edit-role.component.html"
})

export class EditRoleComponent {

    constructor(
        private router: Router,
        private localStorageService: LocalStorageService,
        private editRoleService: EditRoleService,
        private AuthService: AuthenticationService,
        private modalService: NgbModal
    ) { }

    // @ViewChild("EditRoleModal") public EditRoleModal: any;
    @ViewChild("content") content: any;
    ngbModalRef: NgbModalRef;

    userSearch: UserModel = new UserModel();
    userArray: Array<UserRoleListModel> = new Array<UserRoleListModel>();
    userLabel: Array<UserRoleListModel> = new Array<UserRoleListModel>();
    userPermission: Array<number> = [];
    email: string = "";
    count: number = 0;
    num: number = 0;

    show(): void {
        this.ngbModalRef = this.modalService.open(this.content);
        // this.EditRoleModal.show();
    }

    searchemail(): void {
        this.editRoleService.searchUserBackOffice(this.email)
        .subscribe(
            Response => {
                this.userSearch = Response;
                this.userArray = this.userSearch.data;
            },
            err => {
                // unauthorized refresh token
                console.log("unauth");
                if (err.status === 401) {
                    this.AuthService.refreshSessionToken()
                    .subscribe(
                        Response => {
                            // Update session
                            this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);
                             
                            this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                        }
                    );
                } else {
                    this.router.navigate(["/home"]);
                }
            }
        );
    }

    setPermissionUser(userData: UserRoleListModel, check: HTMLInputElement): void {
        userData.check = check.checked;

        if (check.checked === true) {
            this.userLabel.push(userData);
        } else {
            const index = this.userLabel.findIndex(item => {
                return item.userSurrKey === userData.userSurrKey; // use unique value instead of item object
            });
            if (index > -1) {
            this.userLabel.splice(index, 1);
            }
        }
    }

    checkarray(userData: UserRoleListModel): boolean {
        const index = this.userLabel.findIndex(item => {
            return item.userSurrKey === userData.userSurrKey; // use unique value instead of item object
        });
        if (index !== -1) {

            return true;
        } else {

            return false;
        }
    }

    saveModal(): void {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.userLabel.length; i++) {
            if (this.userLabel[i].check === true) {
                this.userPermission[this.count] = this.userLabel[i].userSurrKey;
                this.count++;
            }
        }
        this.editRoleService.updateBackOffice(this.userPermission)
        .subscribe(
            Response => {
                const isSuccess = Response;
                if (isSuccess === true) {
                    // this.saveModal.show();
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);

                } else {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                }
                this.userPermission = [];
                this.count = 0;
            },
            err => {
                // unauthorized refresh token
                console.log("unauth");
                if (err.status === 401) {
                    this.AuthService.refreshSessionToken()
                    .subscribe(
                        Response => {
                            // Update session
                            this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);
                             
                            this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                        }
                    );
                } else {
                    this.router.navigate(["/home"]);
                }
            }
        );
    }
    // Hide modal
    hide(): void {
        // this.EditRoleModal.hide();
        this.ngbModalRef.close();
    }
}
